import { Injectable, EventEmitter } from '@angular/core';
import { ZONE } from '../zone/zone.service';

@Injectable({
  providedIn: 'root'
})
export class DistrictService {
  is_display_district_register_component = false;
  DistrictUpdate = new EventEmitter<ZONE>();

  downloadDistrict = new EventEmitter<boolean>();

  private _district_data: DistrictType = null;
  constructor() { }

  set set_district_data(district) {
    this._district_data = district;
  }

  get get_district_data() {
    return this._district_data;
  }
}


export interface DistrictType {
  id: number;
  name: string;
}
